import _ from 'lodash';
import Vue from 'vue';

export default {
  activateTab (tabToActivate, tabs) {
    tabs.forEach(tab => {
      tab.isActive = (tab.id === tabToActivate.id);
    });
    return tabs;
  },

  addTab (tabToAdd, tabs) {
    const existingTab = tabs.find(tab => tab.id === tabToAdd.id);
    const existingComponent = tabs.find(tab => tab.component === tabToAdd.component);

    if (_.isNil(existingTab)) {
      if (_.isNil(existingComponent) || (!_.isNil(existingComponent) && !existingComponent.isSingleton)) {
        tabs.push(tabToAdd);
      }
    }

    return tabs;
  },

  removeTab (tabToRemove, tabs) {
    if (tabs.length <= 1 || !tabToRemove.isCloseable) return tabs;

    let tabToLeftIndex = null;
    let tabToRemoveIndex = null;
    for (const [index, tab] of tabs.entries()) {
      if (index !== 0) {
        tabToLeftIndex = index - 1;
      }
      tabToRemoveIndex = index;

      if (tab.id === tabToRemove.id) {
        break;
      }
    };

    Vue.delete(tabs, tabToRemoveIndex);

    const hasActiveTab = _.some(tabs, tab => tab.isActive === true);
    if (!hasActiveTab) {
      if (!_.isNil(tabs[tabToRemoveIndex])) {
        for (let i = 0; i < tabs.length; i++) {
          tabs[i].isActive = tabToRemoveIndex === i;
        }
      } else if (!_.isNil(tabs[tabToLeftIndex])) {
        for (let i = 0; i < tabs.length; i++) {
          tabs[i].isActive = tabToLeftIndex === i;
        }
      }
    }
    return tabs;
  }
};
